import React from "react";
import { dateToString, thousandFormatter } from "~/utils/formatter";
import FusionCharts from "fusioncharts";
import charts from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import ReactFusionCharts from "react-fusioncharts";

import { CautionIcon } from "~/assets/svg/InterfaceIcon";
import { useTranslation } from "react-i18next";
import { INVEST_STEP } from "~/constant/ApplyFormConstant";

FusionCharts.options.creditLabel = false;
ReactFusionCharts.fcRoot(FusionCharts, charts, FusionTheme);

const InvestHistory = ({ portfolio, config, dataset }) => {
	const { t } = useTranslation();

	return (
		<>
			<li className="detail-info-item history">
				<h4 className="detail-info-title">
					{t("pages.portfolio.PortfolioView.components.InvestHistory.name")}
				</h4>
				<div className="invest-chart-wrap">
					<div className="invest-execution-chart">
						{portfolio?.StartupInvest?.length > 0 ? (
							<ReactFusionCharts
								{...{
									...config,
									dataSource: {
										...config.dataSource,
										...dataset,
									},
								}}
							/>
						) : (
							<div className="c__noData">
								<CautionIcon />
								<p className="main">
									{t(
										"pages.portfolio.PortfolioView.components.InvestHistory.noData"
									)}
								</p>
							</div>
						)}
					</div>
					<ul className="invest-num">
						<li>
							{t(
								"pages.portfolio.PortfolioView.components.InvestHistory.currentRound"
							)}{" "}
							<b>{INVEST_STEP[portfolio.StartupInvestStatus - 1]}</b>
						</li>
						<li>
							{t("pages.portfolio.PortfolioView.components.InvestHistory.makeInvest")}{" "}
							<b>
								{thousandFormatter(portfolio.StartupInvestTotal) || 0}
								{t(
									"pages.portfolio.PortfolioView.components.InvestHistory.hMillion"
								)}
							</b>
						</li>
					</ul>
				</div>
			</li>
			<li className="detail-info-item c__table invest-history-table">
				<div className="thead">
					<div className="tr">
						<div className="th date">
							{t(
								"pages.portfolio.PortfolioView.components.InvestHistory.investPoint"
							)}
						</div>
						<div className="th name">
							{t(
								"pages.portfolio.PortfolioView.components.InvestHistory.investCompany"
							)}
						</div>
						<div className="th step">
							{t(
								"pages.portfolio.PortfolioView.components.InvestHistory.investStage"
							)}
						</div>
						<div className="th amount">
							{t(
								"pages.portfolio.PortfolioView.components.InvestHistory.investAmount"
							)}
						</div>
						<div className="th amount">당시벨류</div>
					</div>
				</div>
				<div className="tbody">
					{portfolio.StartupInvest?.length <= 0 && (
						<div className="tr notice">
							<div className="c__noData">
								<CautionIcon />
								<p className="main">
									{t(
										"pages.portfolio.PortfolioView.components.InvestHistory.noHistory"
									)}
								</p>
							</div>
						</div>
					)}
					{/*데이터있을때*/}
					{portfolio?.StartupInvest?.map((invest) => {
						return (
							<div key={invest.idx} className="tr">
								<div className="td date">
									{dateToString(invest.date, "yyyy-MM-dd")}
								</div>
								<div className="td name">{invest.name}</div>
								<div className="td step">{INVEST_STEP[invest.step - 1]}</div>
								<div className="td amount">
									{thousandFormatter(invest.value) || 0}억
								</div>
								<div className="td amount">
									{thousandFormatter(invest.comValue) || 0}억
								</div>
							</div>
						);
					})}
				</div>
			</li>
		</>
	);
};

export default InvestHistory;
